import api from './api'

const walletWatchService = {
  getWalletWatches: ({ search = '', skipCount = 0, totalCount = 10 }) =>
    api.get('/api/WalletWatches', {
      params: {
        Search: search,
        SkipCount: skipCount,
        TotalCount: totalCount
      }
    })
}

export default walletWatchService
